"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dueDateForTimeOnDate = exports.formatDateForTimeDisplay = exports.formatMomentForTimeDisplay = void 0;
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("./constants");
const formatMomentForTimeDisplay = function (m) {
  let is24Hour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return m ? m.format(is24Hour ? constants_1.FORMAT_STRING_TIME_24 : constants_1.FORMAT_STRING_TIME_12) : null;
};
exports.formatMomentForTimeDisplay = formatMomentForTimeDisplay;
const formatDateForTimeDisplay = function (d) {
  let is24Hour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return d ? (0, exports.formatMomentForTimeDisplay)((0, moment_1.default)(d), is24Hour) : null;
};
exports.formatDateForTimeDisplay = formatDateForTimeDisplay;
const dueDateForTimeOnDate = function (time) {
  let date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  const dueMoment = (0, moment_1.default)(time, "HH:mm:ss");
  const dueDate = new Date(date.valueOf());
  dueDate.setHours(dueMoment.hours());
  dueDate.setMinutes(dueMoment.minutes());
  dueDate.setSeconds(dueMoment.seconds());
  dueDate.setMilliseconds(0);
  return dueDate;
};
exports.dueDateForTimeOnDate = dueDateForTimeOnDate;